import React from 'react';
import PropTypes from 'prop-types';

import { trafficColorsClass } from 'utils/general';

class BarsCompare extends React.Component {
  componentDidMount() {
    this.setSvg(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.setSvg(nextProps);
  }

  setSvg(props) {
    const { data, id, isComposite, title } = props;
    const heightConst = isComposite ? 110 : 65;
    const margin = { top: isComposite ? 70 : 20, right: 170, bottom: 40, left: 30 };
    const width = 460 - margin.left - margin.right;
    const height = (heightConst + (24 * data.length)) - margin.top - margin.bottom;
    const highlightField = data.length ? data[0] : [];

    // Remove svg to avoid append
    const svgEl = d3.select(`#${id} svg`)[0];
    svgEl[0] && svgEl[0].remove();

    const x = d3.scale.linear()
        .range([0, width]);

    const y = d3.scale.ordinal()
        .rangeRoundBands([0, height], 0.1);

    const z = d3.scale.ordinal()
        .range([0, height], 0.1);

    const xAxis = d3.svg.axis()
        .scale(x)
        .orient('bottom')
        .tickFormat(Math.abs);

    const zAxis = d3.svg.axis()
      .scale(z)
      .orient('top')
      .tickSize(0);

    const yAxis = d3.svg.axis()
        .scale(y)
        .orient('right')
        .tickSize(0)
        .tickPadding(190)
        .tickFormat(componentName => componentName.length > 25 ? `${componentName.slice(0, 25)}...` : componentName);

    const svg = d3.select(`#${id}`).append('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
      .append('g')
        .attr('transform', `translate(${margin.left}, ${margin.top})`);

    x.domain([-100, 100]);
    y.domain(data.map((d) => d.name));
    z.domain([highlightField.name]);

    svg.append('g')
        .attr('class', 'x axis')
        .attr('transform', `translate(0, ${height})`)
        .call(xAxis);

    svg.append('g')
        .attr('class', 'z axis')
        .attr('transform', `translate(${x(0)}, -5)`)
        .call(zAxis)
        .selectAll('.tick text')
          .attr('class', (d, i) => data[i].value1 === null && data[i].value2 === null ? '-no-data' : '');

    svg.append('g')
        .attr('class', 'y axis')
        .attr('transform', `translate(${x(0)}, 0)`)
        .call(yAxis);

    isComposite &&
      svg.append('g')
        .attr('class', 'title')
        .attr('transform', `translate(${x(0) + 45}, -45)`)
        .call(zAxis)
        .selectAll('.tick text')
          .attr('class', 'title-item')
          .html(title[1]);

    isComposite &&
      svg.append('g')
        .attr('class', 'title')
        .attr('transform', `translate(${x(0) - 55}, -45)`)
        .call(zAxis)
        .selectAll('.tick text')
          .attr('class', 'title-item')
          .html(title[0]);

    // translates to left labels from y axis
    svg
      .select('.y')
        .selectAll('.tick text')
          .attr('class', (d, i) => data[i].value1 === null && data[i].value2 === null ? '-no-data' : '')
          .attr('x', '145');

    // Add both bar groups
    this.appendBars(svg, x, y, 'value1', true, props);
    this.appendBars(svg, x, y, 'value2', false, props);
  }

  appendBars(svg, x, y, valueName, positive, props) {
    const { data, isComposite } = props;
    const tooltip = d3.selectAll('.c-tooltip-graph');

    svg.selectAll(`.bar${positive ? '1' : '2'}`)
      .data(data)
      .enter()
        .append('rect')
        .attr('class', (d) => `bar -${positive ? 'second' : 'first'} ${trafficColorsClass(d[valueName]) || '-no-data'}`)
        .attr('x', (d) => {
          const value = positive ? d[valueName] : -d[valueName];
          const noDataValue = positive ? x(0) : x(-100);
          const xVal = x(Math.min(0, value));
          return d[valueName] ? xVal : noDataValue;
        })
        .attr('y', (d, i) => (i === 0 && !isComposite) ? y(d.name) - 10 : y(d.name))
        .attr('width', (d) => d[valueName] ? Math.abs(x(d[valueName]) - x(0)) : x(100) - x(0))
        .attr('height', '7')
        .attr('transform', 'translate(0, 7)')
        .on('mousemove', (d) => {
          tooltip
            .style('left', `${d3.event.pageX - 50}px`)
            .style('top', `${d3.event.pageY - 70}px`)
            .style('display', 'flex')
            .html(`<span class="title">${d.name}</span>
              <div class="double">
                <span class="value">${d.value2 !== null ? d.value2 : 'Not covered'}</span>
                <span class="value">${d.value1 !== null ? d.value1 : 'Not covered'}</span>
              </div>`);
        })
        .on('mouseout', () => tooltip.style('display', 'none'));
  }

  render() {
    return (
      <div id={this.props.id} className="c-bars-compare"></div>
    );
  }
}

BarsCompare.propTypes = {
  data: PropTypes.array,
  id: PropTypes.string,
  title: PropTypes.any,
  isComposite: PropTypes.bool
};

export default BarsCompare;



// WEBPACK FOOTER //
// ./app/components/common/charts/BarsCompare.jsx